/**
 * Datos del contrato vigente.
 *
 * Estaban escritos a mano dentro del Resumen, y eso hacía que el semáforo
 * anunciara un contrato excedido aunque no hubiera una sola guía cargada: el
 * número no salía de los datos, venía fijo en el código.
 *
 * Ahora vive en la base, se edita desde Administración y, si no está
 * configurado, el Resumen no afirma nada.
 *
 * Sobre `cobradoAcumuladoUf`: es lo facturado **antes** de la app, los estados
 * de pago 1 al 58 que estaban en la planilla. Es un dato que se ingresa, no
 * uno que se calcule, y la pantalla lo dice. Cuando la app emita sus propios
 * estados de pago habrá que sumarlos a esta base.
 */

import { COL } from './firebase';
import { guardar, leerDoc } from './repositorio';
import { metaNueva } from './tiposDatos';

/** Un solo contrato vigente por ahora; el identificador es fijo. */
export const ID_CONTRATO = 'vigente';

export interface DocContrato {
  id: string;
  /** Identificación del contrato, como aparece en los documentos. */
  numero: string;
  montoBaseUf: number;
  montoModificacionesUf: number;
  /** Facturado antes de la app. Se ingresa a mano. */
  cobradoAcumuladoUf: number;
  /** Valor de la UF usado para expresar el exceso en pesos. */
  valorUf: number;
}

/** Lo que decía el contrato en la planilla, para arrancar con algo real. */
export const CONTRATO_INICIAL: Omit<DocContrato, 'id'> = {
  numero: 'GD KM 13 NV 17',
  montoBaseUf: 289602,
  montoModificacionesUf: 104423,
  cobradoAcumuladoUf: 416012.504,
  valorUf: 40860.6,
};

/** El contrato vigente, o `null` si todavía no se configuró. */
export async function leerContrato(): Promise<DocContrato | null> {
  return await leerDoc<DocContrato>(COL.contratos, ID_CONTRATO);
}

export async function guardarContrato(
  datos: Omit<DocContrato, 'id'>,
  usuarioId: string | null = null,
): Promise<DocContrato> {
  const doc: DocContrato = {
    ...metaNueva(usuarioId),
    ...datos,
    id: ID_CONTRATO,
  };
  await guardar(COL.contratos, doc);
  return doc;
}
